<main role="main" data-pgr-id="tleCoverage" class="h-full">
  <div class="lg-container">
    <div class="flex justify-between">
      <h1 class="cui-h1 mb-xxs" id="main-content-header" tabindex="-1">
        Coverage
      </h1>
    </div>
    <cui-accordion>
      <cui-accordion-item class="mb-bl-2" data-pgr-id="cvqAccordion">
        <cui-accordion-header>
          <div>
            <mat-panel-title class="flex-grow-0 flex-shrink-0">
              <span class="cui-h2" id="cvqs">CVQ</span>
            </mat-panel-title>
            <span class="cui-h5" data-pgr-id="resolvedCvqText">
              {{ resolvedCvqCount$ | async }} out of
              {{ (cvqs$ | async).length }} Resolved
            </span>
          </div>
        </cui-accordion-header>
        <cui-accordion-body>
          <cla-cvq-tab> </cla-cvq-tab>
        </cui-accordion-body>
      </cui-accordion-item>
    </cui-accordion>
    <cla-uw-memo-landing [claimNumber]="claimNumber" [userId]="userId">
    </cla-uw-memo-landing>
  </div>
  <hr size="2px" width="94%" color="lightgrey" />
  <div data-pgr-id="policyPanel" class="lg-container">
    <div class="flex justify-between mb-xs items-center">
      <h1 class="cui-h1 mb-xxs">Policy</h1>
      @if (isLoading$ | async) {
      <span class="ghost-line w-10"></span>
      } @else { @if (claimInfo$ | async; as claimInfo) {
      <span
        ><b>As of Loss Date: </b>{{ zoneParsedDateOfLoss | claValueOrNA }}</span
      >
      } }
    </div>
    <div class="mt-bl-2">
      @if (isLoading$ | async) {
      <div>
        <cla-coverage-policy-container-ghost-loader></cla-coverage-policy-container-ghost-loader>
      </div>
      } @else { } @if (claimPolicy$ | async; as claimPolicy) {
      <mat-card
        role="region"
        aria-labelledby="policyHeader"
        class="policy-card"
      >
        @if (claimPolicy?.isPolicyAttached) {
        <div class="flex justify-between">
          <div class="flex items-center">
            <mat-icon class="veh-svg" svgIcon="{{ svgImage }}"></mat-icon>
            <div>
              <div class="flex justify-between">
                <h2 class="cui-h2" data-pgr-id="policyTitle" id="policyHeader">
                  {{ claimPolicy.productDesc | titlecase }}
                  @if ( claimPolicy.productDesc && claimPolicy.policyNumber ) {
                  <span>-</span>
                  } #{{ claimPolicy.policyNumber | titlecase }}@if (
                  claimPolicy.policyNumber && claimPolicy.renewalSuffixNumber )
                  {
                  <span>-</span>
                  }{{
                    claimPolicy.renewalSuffixNumber | titlecase | number: "3.0"
                  }}
                  @if (claimInfo$ | async; as claimInfo) {
                  <span>
                    - {{ claimInfo.policyState.description | titlecase }}
                  </span>
                  }
                </h2>
              </div>
              <div class="flex">
                @if (policyStatus$ | async; as policyStatus) {
                <cui-status-indicator
                  [status]="
                    !!statusIndicators[policyStatus?.code]
                      ? statusIndicators[policyStatus?.code]
                      : 'alert'
                  "
                  [background]="false"
                  data-pgr-id="policyStatusIndicator"
                >
                  <span class="screen-reader-only">Status</span
                  >{{ policyStatus?.description }}
                </cui-status-indicator>
                } @if (isThirdPartyIndicator) {
                <div>
                  <cui-status-indicator
                    status="alert"
                    [background]="false"
                    data-pgr-id="thirdPartyIndicator"
                  >
                    Third Party Designee
                  </cui-status-indicator>
                  <mat-icon
                    class="ml-bl-2 text-gray-600 align-middle"
                    aria-hidden="false"
                    aria-label="Third Party Designee exists. Please go to Policy to view details."
                    matTooltip="Third Party Designee exists. Please go to Policy to view details."
                  >
                    help
                  </mat-icon>
                </div>
                }
              </div>
            </div>
          </div>
          <cui-data-list [border]="false">
            <cui-data-list-row label="Effective">
              {{
                claimPolicy?.policyStartDate | date: "MM/dd/yyyy" | claValueOrNA
              }}
              -
              {{
                claimPolicy?.policyEndDate | date: "MM/dd/yyyy" | claValueOrNA
              }}
            </cui-data-list-row>
            @if (isBusiness) {
            <cui-data-list-row label="Company">
              {{ businessName | titlecase | claValueOrNA }}
            </cui-data-list-row>
            } @else {
            <cui-data-list-row label="Named Insured">
              {{ namedInsured | titlecase | claValueOrNA }}
            </cui-data-list-row>
            }
            <cui-data-list-row label="Cancellation Date">
              {{ cancelDate | date: "MM/dd/yyyy" | claValueOrNA }}
            </cui-data-list-row>
          </cui-data-list>
        </div>
        @if (claimCoverages$ | async; as claimCoverages) {
        <div class="card-body">
          <cla-claim-coverage
            [claimCoverages]="claimCoverages"
            [policyAttachVehicle]="policyAttachVehicle$ | async"
            [policyTitle]="policyTitle"
            [dateOfLoss]="dateOfLoss"
            [lossVehicles]="policyLossVehicles$ | async"
            [partyDrivers]="partyDrivers$ | async"
          >
          </cla-claim-coverage>
        </div>
        }
        <mat-tab-group
          class="mt-bl-2"
          mat-align-tabs="start"
          mat-stretch-tabs="false"
        >
          <mat-tab label="Insured">
            @if ( policyDetail$ | async) { @if (policyDetail$ | async; as
            policyDetail) {
            <div class="flex flex-wrap items-start p-bl-1">
              <div
                class="card min-w-sm max-w-sm mr-xxs mb-xxs"
                role="region"
                aria-labelledby="policyDetails"
              >
                <div class="card-header">
                  <h3 class="cui-body" id="policyDetails">
                    <b>Details</b>
                  </h3>
                </div>
                <div class="card-body">
                  <cla-policy-info
                    [policyDetailInput]="policyDetail"
                    [agreementLookupInput]="agreementLookup$ | async"
                  >
                  </cla-policy-info>
                </div>
              </div>
              <div
                class="card mr-xxs min-w-sm mb-xxs"
                role="region"
                aria-labelledby="policyNameInsured"
              >
                <div class="card-header">
                  <h3 class="cui-body" id="policyNameInsured">
                    <b>Named Insured</b>
                  </h3>
                </div>
                <div class="card-body">
                  <cla-policy-name-insured
                    [policyDetail]="policyDetail"
                    [agreementLookupInput]="agreementLookup$ | async"
                  >
                  </cla-policy-name-insured>
                </div>
                <div class="ani">
                  <cla-policy-additional-name-insured
                    [policyDetail]="policyDetail"
                  >
                  </cla-policy-additional-name-insured>
                </div>
              </div>
              <div
                class="card mr-xxs min-w-sm"
                role="region"
                aria-labelledby="policyAgent"
              >
                <div class="card-header">
                  <h3 class="cui-body" id="policyAgent"><b>Agent</b></h3>
                </div>
                <div class="card-body">
                  <cla-policy-agent-info
                    [policyDetail]="policyDetail"
                    [agentInfo]="agentInfo$ | async"
                  >
                  </cla-policy-agent-info>
                </div>
              </div>
            </div>
            } } @else {
            <cui-empty-state
              icon="people"
              primaryText="INSURED"
              secondaryText="Currently unable to load insured information for this policy."
            >
            </cui-empty-state>
            }
          </mat-tab>
          <mat-tab>
            <ng-template mat-tab-label>
              <div class="cui-tab-counter">
                {{
                  (policyAttachVehicle$ | async)
                    ? (policyAttachVehicle$ | async)?.length
                    : 0
                }}
              </div>
              Vehicles
            </ng-template>
            @if ( (isPolicyVehicleLoading$ | async) == true) {
            <cui-empty-state icon="search" primaryText="Loading Vehicles">
            </cui-empty-state>
            } @else { @if ( (policyAttachVehicle$ | async)?.length) {
            <cla-vehicles-container></cla-vehicles-container>
            } @else {
            <cui-empty-state icon="search_off" primaryText="No Vehicles Found">
            </cui-empty-state>
            } }
          </mat-tab>
          <mat-tab>
            <ng-template mat-tab-label>
              <div class="cui-tab-counter">
                {{
                  (policyDrivers$ | async)
                    ? (policyDrivers$ | async)?.length
                    : 0
                }}
              </div>
              Drivers
            </ng-template>
            @if ( (isPolicyDriversLoading$ | async) == true) {
            <cui-empty-state icon="search" primaryText="Loading Drivers">
            </cui-empty-state>
            } @else { @if ( (policyDrivers$ | async)?.length) {
            <cla-policy-drivers
              [claimNumber]="claimNumber"
              [policyDrivers]="policyDrivers$ | async"
            >
            </cla-policy-drivers>
            } @else {
            <cui-empty-state icon="search_off" primaryText="No Drivers Found">
            </cui-empty-state>
            } }
          </mat-tab>
          <mat-tab>
            <ng-template mat-tab-label>
              <div class="cui-tab-counter">
                {{
                  (policyEndorsements$ | async)
                    ? (policyEndorsements$ | async)?.length
                    : 0
                }}
              </div>
              Endorsements
            </ng-template>
            @if ( (isEndorsementsLoading$ | async) == true) {
            <cui-empty-state icon="search" primaryText="Loading Endorsements">
            </cui-empty-state>
            } @else { @if ( (policyEndorsements$ | async)?.length) {
            <cla-policy-endorsements
              [policyEndorsements]="policyEndorsements$ | async"
            ></cla-policy-endorsements>
            } @else {
            <cui-empty-state
              icon="search_off"
              primaryText="No Endorsements Found"
            >
            </cui-empty-state>
            } }
          </mat-tab>
        </mat-tab-group>
        } @else {
        <cui-empty-state
          data-pgr-id="no-policy-attached"
          icon="search"
          primaryText="No policy attached."
          actionText=""
        >
        </cui-empty-state>
        }
      </mat-card>
      }
    </div>
  </div>
</main>
